<template>
  <main class="container padding">
    <div class="header">
      <label class="title">Protocolo de transferência de materiais</label>
      <img src="/logo.png" alt="" class="modal-logo" width="150px" />
    </div>
    <div class="w">
      <b-row>
        <b-col>
          <label>N° Protocolo:</label>
          <br />
          <div class="info">
            {{ relatorioData.siclaProtocolo || "-" }}
          </div>
          <br />

          <label>Responsável CME:</label>
          <div class="info">
            {{ relatorioData.usuario ? relatorioData.usuario.nome : "-" }}
          </div>
          <br />
        </b-col>

        <b-col>
          <label>Data/Hora:</label>
          <div class="info">
            {{ getDateTime(relatorioData.dateTime) }}
          </div>
          <br />

          <label>Unidade Destino:</label>
          <br />
          <div class="info">
            {{ relatorioData ? relatorioData.unidadeDestino : "-" }}
          </div>
          <br />
        </b-col>

        <b-col>
          <label>Unidade:</label>
          <br />
          <div class="info">
            {{ relatorioData.unidade ? relatorioData.unidade.nome : "-" }}
          </div>
          <br />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="div-assinaturas">
            <span>Colaborador CME {{ relatorioData.unidadeOrigem }}: </span>
            <div class="underline"></div>
          </div>
          <br />
          <div class="div-assinaturas">
            <span>Colaborador CME {{ relatorioData.unidadeDestino }}: </span>
            <div class="underline"></div>
          </div>
          <br />
        </b-col>
      </b-row>
    </div>
    <div>
      <b-table
        hover
        :items="relatorioData.materiais"
        :fields="fields"
        class="mt-3 db"
        responsive
      >
        <template #cell(index)="{ index }">
          {{ index + 1 }}
        </template>

        <template #row-details="row">
          <b-card>
            <b-row>
              <b-col>Justificativa: {{ row.item.justificativa }}</b-col>
            </b-row>
          </b-card>
        </template>
      </b-table>
    </div>
  </main>
</template>

<script>
import moment from "moment";

export default {
  name: "RelatorioTransferenciaExpurgo",
  props: {
    relatorioData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    hasMaterialGenerico() {
      return this.relatorioData.materiais.some(
        (mat) => mat.qt_material_generico
      );
    },
  },
  data() {
    return {
      fields: [
        {
          key: "index",
          label: "#",
        },
        {
          key: "tipoMaterial",
          label: "Tipo de Artigo",
        },
        {
          key: "shownId",
          label: "ID",
        },
        {
          key: "descricao",
          label: "Descrição",
        },
        {
          key: "quantidade_itens",
          label: "Qde peças cadastradas",
        },
        {
          key: "quantidade_pecas",
          label: "Qde peças transferidas",
        },
        {
          key: "pertenceA",
          label: "Pertence a",
        },
      ],
    };
  },
  mounted() {
    if (this.hasMaterialGenerico) {
      this.fields = [...this.fields, { key: 'qt_material_generico', label: 'Qtd' }];
    }
  },
  methods: {
    getDateTime(dateTime) {
      return moment(dateTime).local().format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>

<style scoped>
* {
  font-weight: 400;
  font-size: 16px;
}

.padding {
  padding: 36px;
  font-weight: 400;
}

label {
  margin-bottom: 3px;
}

.info {
  margin-bottom: 12px;
}

.underline {
  flex-grow: 1;
  /* width: 100%; */
  border-bottom: 1px solid black;
  margin-left: 5px;
  margin: 0 10px 4px 5px;
}

.div-assinaturas {
  display: flex;
  margin-bottom: 10px;
}

.w h2 {
  font-size: 16px;
  font-weight: 600;
}

.modal-header {
  border-bottom: 0;
}

.header .modal-logo {
  position: absolute;
  right: 20px;
  top: 20px;
  margin-top: 10px;
}

.header .title {
  font-weight: 500;
  font-size: 18px;
  margin-top: -30px;
  margin-bottom: 40px;
  margin-left: -10px;
}
</style>
